<template>
  <div id="app" v-if="pageLoaded">
    <div v-show="$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">{{$store.state.DLINE_ENVIRONMENT}}</div>
    <keep-alive :include="['GoodsList']">
        <!-- 需要缓存的视图组件 -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
      <!-- 不需要缓存的视图组件 -->
     <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
  <div v-else-if="$store.state.browser.wx" class="nothing nothing_load">
<!--    <i class="material-icons big">&#xe52f;</i>-->
<!--    <div>微信授权中,请稍后……</div>-->
    <div><small>微信授权中,请稍候……</small></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      unionid:'',
      pageLoaded: false
    };
  },
  watch: {
    '$route': {
      handler(to, from){
        //console.log(to);
        //console.log(from);
        //console.log(this.$store.state.browser);
        if(this.$store.state.browser.ios && this.$store.state.browser.giantapp){
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; //改为manual之后，就不会记录滚动位置
          }
        }
      },
      immediate: true,//首次进入页面即执行
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  mounted(){
    const _this = this;
    // unionid埋点
    if (_this.$store.state.browser.wx && !_this.$store.state.browser.comwx && localStorage.getItem('is_unionid_auth') != 1) {
      const unionid = sessionStorage.getItem('unionid') || _this.getUrlParam('unionid');
      const is_snapshotuser = sessionStorage.getItem('is_snapshotuser') || _this.getUrlParam('is_snapshotuser');
      if (!unionid) {
        const local = window.location.href;
        const redirectUri = encodeURIComponent(local); // 确保回调 URL 编码正确
        window.location.replace(`https://wechat.giant.com.cn/third/Oauth.aspx?username=giant&scope=snsapi_userinfo&redirect_uri=${redirectUri}`);
        setTimeout(()=>{
          _this.pageLoaded = true;
        },2000)
      } else {
        _this.unionid = unionid;
        sessionStorage.setItem('is_snapshotuser', is_snapshotuser);
        sessionStorage.setItem('unionid', _this.unionid);
        _this.pageLoaded = true;
      }
    }else{
      _this.pageLoaded = true;
      localStorage.removeItem('is_unionid_auth')
    }
    // _this.$toast('当前链接地址'+window.location.href)
  },
  methods: {
    //获取unionid
    getUnionid(){
      const _this = this;
      let local = window.location.href;
      window.location.replace("https://wechat.giant.com.cn/third/Oauth.aspx?username=giant&scope=snsapi_userinfo&redirect_uri="+encodeURIComponent(local)+"");
    },
    getUrlParam(name){
      var url = window.location.href;
      let params = url.substr(url.lastIndexOf("?") + 1).split("&");
      for (let i = 0; i < params.length; i++) {
        let param = params[i];
        let key = param.split("=")[0];
        let value = param.split("=")[1];
        if (key === name) {
          return value;
        }
      }
    },
  }

}
</script>

<style scoped lang="less">
.nothing_load .material-icons.big {
  transform-origin: 50% 100%;
  animation: nothing_load_ani 5s infinite;
}

@keyframes nothing_load_ani {
  0% {
    transform: translate(-10px) rotate(0deg);
  }
  5% {
    transform: translate(-5px) rotate(-10deg);
  }
  20% {
    transform: translate(10px) rotate(3deg);
  }
  50% {
    transform: translate(5px);
  }
  70% {
    transform: translate(10px);
  }
  100% {
    transform: translate(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue